import { render, staticRenderFns } from "./SchedulePostView.vue?vue&type=template&id=bc6b126c&scoped=true&"
import script from "./SchedulePostView.vue?vue&type=script&lang=ts&"
export * from "./SchedulePostView.vue?vue&type=script&lang=ts&"
import style0 from "./SchedulePostView.vue?vue&type=style&index=0&id=bc6b126c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6b126c",
  null
  
)

export default component.exports